module.exports = __webpack_public_path__ + "img/android.8c1c7453.jpg";